(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sf-shop-the-look-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      root.querySelectorAll('[data-product-card]').forEach((card) => {
        const select = card.querySelector('[data-variant-select]');
        const input = card.querySelector('[data-variant-input]');
        const price = card.querySelector('[data-price]');
        const button = card.querySelector('[data-add-button]');
        const label = card.querySelector('[data-button-label]');
        const form = card.querySelector('.sf-shop-look__form');
        const error = card.querySelector('[data-error]');
        if (select) select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];
          input.value = option.value;
          price.textContent = option.dataset.price;
          const available = option.dataset.available === 'true';
          button.disabled = !available;
          label.textContent = available ? 'Toevoegen' : 'Uitverkocht';
        });
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (button.disabled) return;
          button.disabled = true;
          error.hidden = true;
          label.textContent = 'Toevoegen…';
          try {
            const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || 'Dit artikel kon niet worden toegevoegd.');
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            if (window.Alpine && Alpine.store('xMiniCart')) {
              await Alpine.store('xMiniCart').reLoad();
              Alpine.store('xMiniCart').openCart();
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }
            label.textContent = 'Toegevoegd';
            window.setTimeout(() => { label.textContent = 'Toevoegen'; button.disabled = false; }, 1200);
          } catch (err) {
            error.textContent = err.message;
            error.hidden = false;
            label.textContent = 'Toevoegen';
            button.disabled = false;
          }
        });
      });
    };
    const boot = () => document.querySelectorAll('.sf-shop-look').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.sf-shop-look')));
  })();

  } catch(e) { console.error(e); }
})();
})();
